<template>
  <div>
    <main-header-plat-a />
    <div style="position: relative">
      <main-header-plat-b :navBItems="navBItems" />
    </div>
    <a class="black--text">Terapia</a>
  </div>
</template>

<script>
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';

export default {
  name: 'ProPatientsCRTherapyPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
  },
  data() {
    return {
      navBItems: [
        { name: 'Anamnesis', to: '/pacientes/perfil/hcp/anamnesis/index' },
        { name: 'Pruebas', to: '/pacientes/perfil/hcp/pruebas/aplicadas' },
      ],
    };
  },
};
</script>
